import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $asset, $http } from '@/axios';
import { sleep } from '@/utils/helper';

// 查询当前导航树
export const queryCurrentNav: IActionFn<IModuleState> = ({ commit, state }, payload) => {
  const name1 = 'Component_TEST';
  const name2 = 'Furniture_TEST';
  const fetchNav1 = $http.get(`/v1/baseinfo/nav/${name1}/detail`);
  const fetchNav2 = $http.get(`/v1/baseinfo/nav/${name2}/detail`);

  commit('setCurrentNav', { ...state.currentNav, loading: true });
  Promise.all([fetchNav1, fetchNav2]).then(async (results) => {
    const [tree1 = null, tree2 = null] = results;
    // 这里表示根节点里没有 id 时, 则 id 值用 -1 填充; 有 id 时, 则使用请求结果里的 id
    const root1 = { id: -1, entityType: 'Component', ...tree1, name: '零件' };
    const root2 = { id: -2, entityType: 'Furniture', ...tree2, name: '模块' };
    await sleep(2);
    commit('setCurrentNav', { raw: [root1, root2] });
  }).catch(() => {
    commit('setCurrentNav', { data: [] });
  });
};

// 查询已发布的导航树
export const queryPublishedNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    // commit('setPublishedNav', { ...state.dialog, loading: true });
    await sleep(2);
    // $asset('oss', `data/navigation_${name}.json`, { ignoreCodes: [404] });
  } finally {
    commit('setPublishedNav', { data: [] });
  }
};

// 发布当前导航
export const publishCurrentNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
    // $asset('oss', `data/navigation_${name}.json`, { ignoreCodes: [404] });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除当前导航
export const deleteCurrentNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除当前已发布导航
export const deletePublishedNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 查询历史导航列表
export const queryVersionList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setVersionList', { ...state.versionList, loading: true });
    const res = await $asset('static', '/mock/navigation-versions.json');
    await sleep(2);
    commit('setVersionList', { data: res });
  } catch (e) {
    commit('setVersionList', { data: [] });
  }
};

// 查询历史导航详情
export const queryVersionDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setVersionDetail', { ...state.versionTree, loading: true });
    const res = await $asset('static', '/mock/navigation.json');
    commit('setVersionDetail', { data: res });
  } catch (e) {
    commit('setVersionDetail', { data: [] });
  }
};

// 发布历史导航
export const publishVersionNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除历史导航
export const deleteVersionNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 保存历史导航
export const saveVersionNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 用历史导航覆盖当前导航
export const coverWithVersionNav: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 新增导航节点
export const addNavNode: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑导航节点
export const editNavNode: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setNodeSaving', true);
    await sleep(2);
  } finally {
    commit('setNodeSaving', false);
  }
};

// 删除导航节点
export const deleteNavNode: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    await sleep(2);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 排序导航节点
export const sortNavNode: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setNodeSort', { ...state.nodeSort, loading: true });
    await sleep(2);
  } finally {
    commit('setNodeSort', { id: null, loading: false });
  }
};

// 保存节点配置
export const saveNavNodeConfig: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfigSaving', true);
    await sleep(2);
  } finally {
    commit('setConfigSaving', false);
  }
};

// 根据节点配置搜索
export const searchWithNodeConfig: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setPreviewList', { ...state.previewList, loading: true });
    await sleep(2);
    commit('setPreviewList', { data: [], pageNum: 1, pageSize: 10, total: 0 });
  } catch (e) {
    commit('setPreviewList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};
